import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { text } from "../../text";
import { hooks } from "../../hooks";
import { theme } from "../../constants";
import { components } from "../../components";
import { APP_ROUTES } from "../../constants/app_routes";
import { SmallLogoSvg } from "../../assets/svg/SmallLogoSvg";

export const AuthScreen: React.FC = () => {
  const navigate = hooks.useNavigate();
  const { t } = useTranslation();

  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderLogo = (): JSX.Element => {
    return (
      <div className="auth-logo">
        <SmallLogoSvg />
        <text.T18>iq broker</text.T18>
      </div>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <>
        <text.H4>{t("welcome")} IQ Broker!</text.H4>
        <components.Button
          title={t("signUpWithEmailOrPhone")}
          style={{ marginBottom: 20 }}
          onClick={() => navigate(APP_ROUTES.REGISTER)}
        />
      </>
    );
  };

  const renderAlreadyHaveAnAccount = (): JSX.Element => {
    return (
      <div className="auth-already">
        <text.T16 style={{ color: theme.colors.white, marginRight: 5 }}>
          {t("alreadyHaveAccount")}
        </text.T16>
        <text.T16
          style={{
            color: theme.colors.accentColor,
            ...theme.fonts.Lato_700Bold,
            cursor: "pointer",
            userSelect: "none",
            marginLeft: "10px",
          }}
          onClick={() => navigate(APP_ROUTES.LOGIN)}
        >
          {t("login")}
        </text.T16>
      </div>
    );
  };

  return (
    <main className="container auth" style={{ paddingBottom: 0 }}>
      {renderLogo()}
      {renderButton()}
      {renderAlreadyHaveAnAccount()}
    </main>
  );
};
